import * as React from 'react'
import {Container, Typography} from "@mui/material";
import SignInForm from "./SignInForm";
import SignUp from "../sign-up/SignUp";
import {Button} from "../../common";
import classes from './signInOrRegister.module.scss';
import clsx from "clsx";
import {ForgotPassword} from "../forgot-password/ForgotPassword";
import BackButton from "../../common/BackButton";

export interface SignInOrRegisterProps {
  screen?: string
  onSuccess?: () => void
}

const SignInOrRegister = (props: SignInOrRegisterProps) => {
  const [screen, setScreen] = React.useState(props.screen || 'signIn')
  const handleSuccess = () => {
    if (props.onSuccess) {
      props.onSuccess();
    }
  }

  const handleSignUpSuccess = () => {
    setScreen('signIn');
  }

  const handleForgotPasswordSuccess = () => {
    setScreen('signIn');
  }

  switch (screen) {
    case 'register':
      return <>
        <div className={clsx(classes.container, 'j-align-center')}>
          <div className="j-mb-3">
            <Typography component="div" variant="h3">Create your account</Typography>
          </div>
          <SignUp
            onSuccess={handleSignUpSuccess}
          />
          <Typography variant="body1" component="a" className={clsx(classes.secondaryLink, 'j-my-2')} onClick={(e: { preventDefault: () => void; }) => {e.preventDefault(); setScreen('signIn')}}>Or sign in</Typography>
        </div>
      </>
    case 'forgot password':
      return <>
        <div className={clsx(classes.container, 'j-align-center')}>
          <Container maxWidth="xs" className={'j-mb-1 j-align-left'}>
            <BackButton onClick={() => setScreen('signIn')} />
          </Container>
          <div className="j-mb-3">
            <Typography component="div" variant="h3">Forgot Password</Typography>
          </div>
          <ForgotPassword
            onSuccess={handleForgotPasswordSuccess}
          />
        </div>
      </>
    default:
      return <>
        <div className={clsx(classes.container, 'j-align-center')}>
          <div className="j-mb-3">
            <Typography component="div" variant="h3">Sign in to your account</Typography>
          </div>
          <SignInForm
            onLogin={handleSuccess}
          />
          <Typography variant="body1" component="a" className={clsx(classes.secondaryLink, 'j-my-2')} onClick={(e: { preventDefault: () => void; }) => {e.preventDefault(); setScreen('forgot password')}}>Forgot password?</Typography>
          <div className={'j-mt-4'}>
            <Typography component="div" variant="h3" className={'j-mb-2'}>Don't have an account?</Typography>
            <Button variant="outlined" onClick={() => setScreen('register')}>Create account</Button>
          </div>

        </div>

      </>
  }
}

export default SignInOrRegister;

